module.exports = __webpack_public_path__ + "img/arrow-right.14ad2078.svg";